import { Typography } from '@doltech/ui/lib/figma/DesignSystemV2/Typography';
import { observer } from 'mobx-react-lite';
import { onAction } from 'mobx-state-tree';
import * as React from 'react';
import { useMount } from 'react-use';

import { useStepStore } from '../../../step-header/model/base-step';
import styled from 'styled-components';

const SamplePreviewMain = styled.div`
  .landing-section-middle {
    padding-top: 24px;
    padding-bottom: 80px;
  }
`;

export const TitleH2Block = ({ className = 'font-noto', children, ...rest }) => {
  return (
    <Typography.Title
      className={className}
      my={0}
      level={2}
      variant="semi-bold/24"
      tabletVariant="semi-bold/32"
      {...rest}
    >
      {children}
    </Typography.Title>
  );
};

export const SamplePreview = observer((props: any) => {
  const { children } = props;
  const stepStore = useStepStore();

  useMount(() => {
    stepStore.getCurrentStep().valid(true);
  });

  React.useEffect(() => {
    const disposer = onAction(stepStore, async (call) => {
      if (call.name === 'validateNextStep') {
        stepStore.nextStep();
      }
    });
    return () => {
      disposer();
    };
  }, [stepStore]);

  return <SamplePreviewMain className="sample-preview-main">{children}</SamplePreviewMain>;
});

export const withSamplePreviewStep = (Component: any) => (props: any) => {
  return (
    <SamplePreview {...props}>
      <Component {...props} />
    </SamplePreview>
  );
};
